import sanitizeHtml from 'sanitize-html';

export const sanitizedAll = (rawText) =>
  sanitizeHtml(rawText, {
    allowedTags: ['a', 'strong', 'p'],
    allowedAttributes: {
      a: ['href', 'target']
    },
    allowedSchemes: ['https']
  });
